import React from "react";

export const MainsIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
    >
      <defs>
        <clipPath>
          <rect
            data-name="Rectangle 1298"
            width="13"
            height="13.006"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 4182" transform="translate(-35 -2.999)">
        <g
          data-name="Ellipse 329"
          transform="translate(35 2.999)"
          fill="#fff"
          stroke="#000"
          strokeWidth="2"
        >
          <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
          <circle cx="12.5" cy="12.5" r="11.5" fill="none" />
        </g>
        <g data-name="Group 4225" transform="translate(15455 5199.793)">
          <g data-name="Group 4224" transform="translate(-15414 -5190.797)">
            <g data-name="Group 4223" clipPath="url(#clipPath)">
              <path
                data-name="Path 2206"
                d="M29.3,0c.036.041.069.084.107.122q5.35,5.351,10.7,10.7a1.659,1.659,0,0,1,.572.941v.2a1.377,1.377,0,0,1-.239.591,1.143,1.143,0,0,1-1.773.055q-1.907-2.128-3.811-4.259l-.428-.477-.6.62c-.056-.052-.089-.081-.121-.112-1.482-1.482-2.958-2.97-4.449-4.442a2.92,2.92,0,0,1-.84-2.5A5.057,5.057,0,0,1,28.819,0Z"
                transform="translate(-27.684)"
              />
              <path
                data-name="Path 2207"
                d="M3.96,291.62l1.611,1.613c-.015.016-.04.044-.066.071Q3.751,295.059,2,296.813a1.142,1.142,0,0,1-1.784-1.422,1.872,1.872,0,0,1,.165-.192q1.758-1.761,3.518-3.519c.023-.023.049-.045.065-.06"
                transform="translate(0 -284.197)"
              />
              <path
                data-name="Path 2208"
                d="M277.724,5.551l2.039-2.039.553.556a.514.514,0,0,0-.1.066c-.812.81-1.631,1.614-2.43,2.436a2.186,2.186,0,0,1-1.476.723.066.066,0,0,0-.025,0c-.213.112-.333-.024-.467-.161-.477-.487-.961-.966-1.446-1.446a.168.168,0,0,1-.048-.188c.035-.143.046-.292.071-.437a1.906,1.906,0,0,1,.54-1.042q1.319-1.321,2.64-2.64a.307.307,0,0,1,.026-.022l.532.531L276.11,3.916l.549.548,2.029-2.03.538.535-2.042,2.042.54.541"
                transform="translate(-267.334 -1.325)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
